// SellerRelatedProductsWrapper.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import SellerRelatedProducts from "../SellerRelatedProducts/SellerRelatedProducts";
import { BaseUrl } from "../../App";
import SellerServicesUrl from "../../SellerServicesUrl";

export default function SellerRelatedProductsWrapper() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("token");
useEffect(() => {
  if (!token) {
    setLoading(false);
    return;
  }

  axios
    .get(BaseUrl + SellerServicesUrl.SellerHome, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      setProducts(res?.data?.data?.products || []);
    })
    .catch((err) => console.error("Wrapper Error:", err))
    .finally(() => {
      setLoading(false);
    });
console.log(products)
}, [token]);
  return (
    <div className="orders-page mb-5 ">
      <div className="container mt-4 mb-5 ">
        <div className="cards-wrapper mt-5">

          {/* ===== Skeleton Loading ===== */}
          {loading &&
            [1, 2, 3].map((i) => (
              <div key={i} className="order-skeleton-card">
                <div className="skeleton-lock"></div>

                <div className="skeleton-middle">
                  <div className="skeleton-line short"></div>
                  <div className="skeleton-line medium"></div>
                </div>

                <div className="skeleton-right">
                  <div className="skeleton-badge"></div>
                  <div className="skeleton-line small"></div>
                </div>
              </div>
            ))}

          {/* ===== Products ===== */}
          {!loading && (
            <SellerRelatedProducts products={products} />
          )}
        </div>
      </div>
    </div>
  );
}
